import {h, Fragment} from "preact"
import { useState } from "preact/hooks"

export default function Select({ value, onChange, className, options }) {
    const [opened, setOpened] = useState(false)

    return (
        <div className="ns-relative" onClick={() => setOpened(!opened)}>
            <span>Sort By</span>
            <ul
                className={`ns-selection-dropdown-menu ns-text-align-left ${className} ${opened ? 'ns-active' : 'ns-d-none'}`}
                value={value}
            >
                {options.map(option => (
                    <li key={option.value} value={option.value}>
                        <a href="#" sortValue={option.value} onClick={(e) => {onChange(e);}}>{option.label}</a>
                    </li>
                ))}
            </ul>
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-nav-arrow-down" viewBox="0 0 24 24"><path d="m6 9 6 6 6-6" stroke="#000" stroke-linecap="round" stroke-linejoin="round"></path></svg>
        </div>
    )
}